import createHoverMonitor from './monitor'
import { element, func, oneOfType } from 'prop-types'
import React, { Component } from 'react'

const hover = createHoverMonitor()

/**
 * source: https://gist.github.com/necolas/1c494e44e23eb7f8c5864a2fac66299a
 */
class Hoverable extends Component {
  static displayName = 'Hoverable';

  static propTypes = {
    children: oneOfType([func, element]).isRequired,
    onHoverIn: func,
    onHoverOut: func
  };

  state = { isHovered: false };

  _handleMouseEnter = e => {
    if (hover.get() && !this.state.isHovered) {
      const { onHoverIn } = this.props
      if (onHoverIn) {
        onHoverIn()
      }
      this.setState(() => ({ isHovered: true }))
    }
  };

  _handleMouseLeave = e => {
    if (this.state.isHovered) {
      const { onHoverOut } = this.props
      if (onHoverOut) {
        onHoverOut()
      }
      this.setState(() => ({ isHovered: false }))
    }
  };

  render () {
    const {
      children
    } = this.props

    const child = typeof children === 'function' ? children(this.state.isHovered) : children

    return React.cloneElement(React.Children.only(child), {
      onMouseEnter: this._handleMouseEnter,
      onMouseLeave: this._handleMouseLeave
    })
  }
}

export default Hoverable
